import { LinkOutlined } from '@ant-design/icons';
import { Empty } from 'antd';
import React, { useState } from 'react';
import { User } from '@/models/user';
import { MoremeClientModalBinder } from '../../pages/Moreme/MoremeClientBinder';
import PosButton from '../PosButton';
import MoremeUserReportList from './MoremeUserReportList';

export type Props = {
  user: User;
  actionAreaClassName?: string;
  onDataChange?: () => void;
};

const MoremeClientInfo: React.FC<Props> = ({ user, actionAreaClassName, onDataChange }: Props) => {
  const [selectorOpen, setSelectorOpen] = useState(false);
  return (
    <>
      {!user || !user.moremeCid ? (
        <Empty description={'当前客户未绑定检测仪'} />
      ) : (
        <div>
          <MoremeUserReportList username={user.username} />
        </div>
      )}
      <div className={actionAreaClassName}>
        {/* <CouponUserOperator user={user} onCouponUserChange={onCouponUserChange} /> */}
        {!user.moremeCid ? (
          <PosButton
            color="primary"
            variant="outlined"
            icon={<LinkOutlined />}
            onClick={() => {
              setSelectorOpen(true);
            }}>
            {'绑定检测仪客户'}
          </PosButton>
        ) : (
          <PosButton color="primary" variant="outlined" icon={<LinkOutlined />} disabled danger>
            {'已绑定'}
          </PosButton>
        )}
      </div>

      <MoremeClientModalBinder
        user={user}
        open={selectorOpen}
        onCancel={() => {
          setSelectorOpen(false);
        }}
        onBindSuccess={() => {
          setSelectorOpen(false);
          onDataChange?.();
        }}
      />
    </>
  );
};

export default MoremeClientInfo;
